import { effect, Injectable, Signal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BreakPointService {
 widthSignal = signal<number>(window.innerWidth);
 breakPointSignal = signal<string>('')
  private breakpoints = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  };

  constructor() {
    // Listen for resize events
    window.addEventListener('resize', this.onResize.bind(this));   
  }

  ngOnInit(){
    this.widthSignal.set(window.innerWidth)
    this.getBreakpoint()
  }

  private onResize() {
    this.widthSignal.set(window.innerWidth);
    this.getBreakpoint()
  }

  get currentWidth(): Signal<number> {
    return this.widthSignal;
  }

 

  public getBreakpoint() {
    const width = this.widthSignal();
    if (width >= this.breakpoints.xl){
      this.breakPointSignal.set('xl') ;
      return
    } 
    if (width >= this.breakpoints.lg){
      this.breakPointSignal.set('lg');
      return
    }
    if (width >= this.breakpoints.md){
      this.breakPointSignal.set('md');
      return
    } 
    if (width >= this.breakpoints.sm){
      this.breakPointSignal.set('sm');
      return
    } 
    this.breakPointSignal.set('xs');
  }
}
